import { instance } from "libs/api";

import { ApiRoutesReturns } from "../../constants";
import { ReturnDetails } from "../../returns.types";

export const requestReturnsDetailsByIds = async (
  orderIds: string[]
): Promise<ReturnDetails[]> => {
  return await instance.post(ApiRoutesReturns.ReturnDetails, { orderIds });
};
